import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "17",
  height: "16",
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M5.79978 2.891C5.79978 1.86491 6.00656 0.889539 6.3811 0C2.82295 0.862229 0.181641 4.06535 0.181641 7.88491C0.181641 12.3638 3.81783 16 8.29673 16C12.1163 16 15.3194 13.3587 16.1816 9.80054C15.2921 10.1751 14.3128 10.3819 13.2906 10.3819C9.15506 10.3819 5.79978 7.02658 5.79978 2.891Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}